<template>
  <div>
    <div class="content" v-for="item in orderData" :key="item.id">
      <van-row align="center" style="margin-top: 5px;">
        <van-col span="12" style="padding-left: 10px;">
          <span>科室：</span>
          <span>{{ item.creatorDeptName }}</span>
        </van-col>
        <van-col span="12">
          <span>缴费金额：</span>
          <span>{{ item.totalAmount }}元</span>
        </van-col>
      </van-row>
      <van-row align="center" style="margin-top: 10px;">
        <van-col span="12" style="padding-left: 10px;">
          <span>缴费时间：</span>
          <span>{{ $moment(item.payeeTime).format('YYYY-MM-DD HH:mm:ss')}}</span>
        </van-col>
        <van-col span="12" style="padding-left: 10px;">
          <span>缴费编号：</span>
          <span>{{item.medicalAdviceCode}}</span>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import {
  jxhospitalOrders
} from "@/api/prescription/hospitalOrders.js";
import { reactive, toRefs } from "vue";

export default {

  setup() {
    const state = reactive({
      orderData: []
    });

    const getOrder = () => {
      jxhospitalOrders({}).then((v) => {
        state.orderData = v.data
      })
    }
    getOrder()


    return {
      ...toRefs(state),
    };
  },
};
</script>

